import { connect } from 'react-redux';
import { compose } from 'redux';
import withPolling from 'utils/withPolling';
import { resetCreatePto } from '../store/createOrder';
import { setCurrentPtoDialogueOpen } from '../store/orderDrawer';
import { fetchSearchPTOs, setCurrentAffiliate } from '../store/searchOrder';
import { resetSearchPtoFilters, updateSearchPtoFilter } from '../store/searchFilters';
import { getPtoDetails, getPtoDetailsError, getPtoDetailsPending } from '../store/orderDetails';
import { fetchOriginators, getOriginatorOptions } from '../store/originators';
import { fetchRecipients, getRecipientsOptions } from '../store/recipients';
import { fetchLocations, locationOptionsSelector } from '../store/locations';
import { fetchPtoNumbers, getPtoNumbersError, getPtoNumbersOptions } from '../store/orderNumbers';
import { fetchReferenceIds, getReferenceIdOptions } from '../store/referenceIds';
import { fetchProducts, getProductOptions } from '../store/products';
import SearchPTO from './Search';

const mapState = state => ({
  currentAffiliate: state.pto.searchPtos.currentAffiliate,
  locationOptions: locationOptionsSelector(state),
  locationsError: state.pto.locations.error,
  originatorOptions: getOriginatorOptions(state),
  pending: state.pto.searchPtos.pending,
  productOptions: getProductOptions(state),
  ptoDetails: getPtoDetails(state),
  ptoDetailsError: getPtoDetailsError(state),
  ptoDetailsPending: getPtoDetailsPending(state),
  ptoList: state.pto.searchPtos.searchPtoList,
  ptoNumberOptions: getPtoNumbersOptions(state),
  ptoNumbersError: getPtoNumbersError(state),
  recipientOptions: getRecipientsOptions(state),
  referenceIdOptions: getReferenceIdOptions(state),
  searchPtoFilters: state.pto.searchPtoFilters,
});

const mapDispatch = {
  fetchLocations,
  fetchOriginators,
  fetchProducts,
  fetchPtoNumbers,
  fetchRecipients,
  fetchReferenceIds,
  fetchSearchPTOs,
  resetCreatePto,
  resetSearchPtoFilters,
  setCurrentAffiliate,
  setCurrentPtoDialogueOpen,
  updateSearchPtoFilter,
};

export default compose(
  connect(mapState, mapDispatch),
  withPolling(fetchSearchPTOs, 60000)
)(SearchPTO);
